/* eslint-disable no-lonely-if */
import React, { useEffect, useState } from "react";
import {
  Routes, Route, useParams,
} from "react-router-dom";
import LoginPage from "../pages/LoginPage";
import NotFoundPage from "../pages/NotFoundPage";
import { isSessionCookieTrue, getVanityFromCookie } from "../../utils/authCookies";

const normalizeVanity = (value) => {
  const vanity = (value || '').trim().toLowerCase();
  return /^[a-z0-9-]+$/.test(vanity) ? vanity : '';
};

const readLoginHint = () => {
  if (typeof window === 'undefined' || !window.location) return '';
  const value = new URLSearchParams(window.location.search).get('login_hint') || '';
  // Light validation — reject anything that doesn't smell like an email so we
  // never forward stray query strings into Entra's login_hint param.
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? value : '';
};

const BrandedLoginPage = () => {
  const { vanity } = useParams();
  const requestedVanity = normalizeVanity(vanity);
  const [branding, setBranding] = useState(null);
  const [loading, setLoading] = useState(true);
  const loginHint = readLoginHint();

  useEffect(() => {
    if (
      isSessionCookieTrue()
      && requestedVanity
      && getVanityFromCookie() === requestedVanity
    ) {
      window.location.assign(
        `https://${requestedVanity}.${process.env.REACT_APP_BASE_DOMAIN}`,
      );
    }
  }, [requestedVanity]);

  useEffect(() => {
    if (!requestedVanity) {
      setLoading(false);
      return undefined;
    }

    const controller = new AbortController();

    const fetchBranding = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/v1/tenant/info/${encodeURIComponent(requestedVanity)}`,
          { signal: controller.signal },
        );
        if (response.ok) {
          setBranding(await response.json());
        }
      } catch (err) {
        // on error, branding stays null and LoginPage uses its defaults
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    };

    fetchBranding();
    return () => controller.abort();
  }, [requestedVanity]);

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center',
      }}
      >
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        <div style={{
          width: 48,
          height: 48,
          borderRadius: '50%',
          border: '5px solid rgba(17, 68, 155, 0.2)',
          borderTopColor: '#11449b',
          animation: 'spin 0.7s linear infinite',
        }}
        />
      </div>
    );
  }

  return <LoginPage requestedVanity={requestedVanity} branding={branding} loginHint={loginHint} />;
};

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<LoginPage />} />
    <Route path="/:vanity" element={<BrandedLoginPage />} />
    <Route path="*" element={<NotFoundPage />} />
  </Routes>
);

export default AppRoutes;
